import { useEffect, useState } from 'react'
import { expenseApi } from '../services/api'

// One fetch per currency and date for the life of the page - a past day's rate
// never changes, and typing an amount should not hit the server on each key.
const cache = new Map()

/**
 * The Bank of Canada rate for a foreign receipt's date, for previewing the CAD
 * estimate. Returns { loading, rate, asOf, markup, unavailable }. Does nothing
 * for CAD.
 */
export function useExchangeRate(currency, date) {
    const [state, setState] = useState({ loading: false })

    useEffect(() => {
        if (!currency || currency === 'CAD' || !date) {
            setState({ loading: false })
            return
        }

        const key = `${currency}|${date}`
        if (cache.has(key)) {
            setState(cache.get(key))
            return
        }

        let cancelled = false
        setState({ loading: true })

        expenseApi.getExchangeRate(currency, date)
            .then(r => {
                const result = r?.success && r.available
                    ? { loading: false, rate: r.rate, asOf: r.asOf, markup: r.markup || 0 }
                    : { loading: false, unavailable: true }
                // A failure is not cached, so the next change of date tries again.
                if (!result.unavailable) cache.set(key, result)
                if (!cancelled) setState(result)
            })
            .catch(() => { if (!cancelled) setState({ loading: false, unavailable: true }) })

        return () => { cancelled = true }
    }, [currency, date])

    return state
}
